import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "correl_admin_token";

export const getAdminToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setAdminToken = (t) => (t ? sessionStorage.setItem(TOKEN_KEY, t) : sessionStorage.removeItem(TOKEN_KEY));

const client = axios.create({ baseURL: `${API}/admin` });
client.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const apiError = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
};

export async function adminLogin(password) {
  const { data } = await client.post("/login", { password });
  setAdminToken(data.token);
  return data;
}
export const adminMe = () => client.get("/me").then((r) => r.data);
export const adminRules = () => client.get("/rules").then((r) => r.data);
export const adminSaveRules = (patch) => client.put("/rules", patch).then((r) => r.data);
export const adminRestore = (name) => client.post(`/restore/${name}`).then((r) => r.data);
export const adminCandidates = (withEmail = false) => client.get("/candidates", { params: { with_email: withEmail } }).then((r) => r.data);
export const adminAlerts = () => client.get("/alerts").then((r) => r.data);
export const adminDeleteAlert = (id) => client.delete(`/alerts/${id}`).then((r) => r.data);
export const adminFeedback = () => client.get("/feedback").then((r) => r.data);
export const adminDeleteFeedback = (id) => client.delete(`/feedback/${id}`).then((r) => r.data);

export async function downloadCandidatesCsv(withEmail = false) {
  const { data } = await client.get("/candidates.csv", { responseType: "blob", params: { with_email: withEmail } });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = withEmail ? "prpathfinder-leads.csv" : "prpathfinder-candidates.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function buildPatch(config) {
  return {
    streams: config.streams.map((s) => ({ id: s.id, cutoff: s.cutoff ?? null, status: s.status, status_note: s.status_note || "", last_verified: s.last_verified || null })),
    grids: Object.fromEntries(
      Object.entries(config.grids).map(([gid, g]) => [gid, {
        factors: g.factors.map((f) => ({ id: f.id, points: f.points ?? null, map: f.map ?? null, bands: f.bands ?? null })),
      }])
    ),
    draws: Object.fromEntries(
      Object.entries(config.draws || {}).map(([sid, rounds]) => [sid, rounds.map((r) => ({
        date: r.date, cutoff: r.cutoff === "" || r.cutoff == null ? null : Number(r.cutoff),
        invitations: r.invitations === "" || r.invitations == null ? null : Number(r.invitations), note: r.note || "",
      }))])
    ),
  };
}
